import { Box, Stack, Text, styled } from '@/theme/index';

export const ResidentResultsHeader = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.main,
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  height: '100px',
  marginBottom: theme.spacing(4),
  display: 'flex',

  [theme.breakpoints.down('sm')]: {
    height: 'fit-content',
    marginBottom: theme.spacing(3),
    flexDirection: 'column',
  },

  '& .icon': {
    height: '80px',
    width: '80px',
    margin: '0 20px 0 0',
    backgroundSize: '80px 80px',
    borderRadius: '40px',
    alignSelf: 'center',

    [theme.breakpoints.down('sm')]: {
      margin: '0 0 16px 0',
    },
  },
}));

export const ResidentResultsHeaderText = styled(Text)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.secondary.main,
  margin: '0',
  alignSelf: 'center',

  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
  },

  '& .highlight': {
    color: theme.palette.primary.contrastText,
  },
}));

export const ResidentsResultsContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  width: '96%',
  maxWidth: '880px',
  margin: '0 auto',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const NoResultsContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  minHeight: '500px',
  paddingTop: theme.spacing(10),
  marginBottom: theme.spacing(3),
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  alignContent: 'center',
}));

export const NoResultsSearch = styled(Stack)`
  width: 100%;

  .MuiGrid-container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
